import { render, staticRenderFns } from "./AddProfilePic.vue?vue&type=template&id=ba99f712&"
import script from "./AddProfilePic.vue?vue&type=script&lang=js&"
export * from "./AddProfilePic.vue?vue&type=script&lang=js&"
import style0 from "./AddProfilePic.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports